import { mergeMap, catchError, map } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { ofType } from 'redux-observable';
import i18next from 'i18next';
import { showNotificationFromError } from 'components/app/store/UserSlice';
import { getRequests } from 'gql/Request';
import RootEpic from 'store/RootEpic';
import RequestListSlice from 'components/pages/console/store/RequestListSlice';

export const listRequestsEpic: RootEpic = (action$) =>
  action$.pipe(
    ofType(RequestListSlice.actions.listRequests),
    mergeMap(({ payload }) =>
      from(getRequests(payload)).pipe(
        map((response) => RequestListSlice.actions.listRequestsSucceeded(response)),
        catchError((error) => of(RequestListSlice.actions.listRequestsFailed(error)))
      )
    )
  );

export const listRequestsFailedEpic: RootEpic = (action$) =>
  action$.pipe(
    ofType(RequestListSlice.actions.listRequestsFailed),
    map(({ payload }) => showNotificationFromError({ msg: i18next.t('FAILED_GET_REQUESTS'), err: payload }))
  );

const RequestListEpics: RootEpic[] = [listRequestsEpic, listRequestsFailedEpic];

export default RequestListEpics;
